// extracted by mini-css-extract-plugin
module.exports = {"title":"AirPressureCard_title__2tgTF","main":"AirPressureCard_main__1gtpG","value":"AirPressureCard_value__ED8t-"};